<div class="day-card">
  <div class="day-info">
    <div class="day-label">
      <div class="day-name">{{ formatDateLabel(day.date) }}</div>
      <div class="day-iso">{{ day.date }}</div>
    </div>
    <label class="day-off-toggle">
      <mat-slide-toggle
        [checked]="day.dayOff"
        (change)="onDayOffChange($event.checked)"
      ></mat-slide-toggle>
      <span>Day off</span>
    </label>
    <div class="submit-flag">
      <span *ngIf="day.submitted" class="submitted">✓ Submitted</span>
      <span *ngIf="!day.submitted" class="not-submitted">Not submitted</span>
    </div>
  </div>

  <div class="day-timeline-wrapper">
    <app-day-timeline
      [date]="day.date"
      [segments]="day.segments"
      [events]="events"
      [disabled]="day.dayOff"
      (segmentsChange)="onSegmentsChange($event)"
    ></app-day-timeline>

    <div class="segment-list">
      <ng-container *ngIf="day.dayOff; else notDayOff">
        <span class="hint italic">Day off — no segments</span>
      </ng-container>
      <ng-template #notDayOff>
        <ng-container *ngIf="day.segments.length === 0; else hasSegments">
          <span class="hint italic"
            >No segments — drag on the timeline to create one</span
          >
        </ng-container>
        <ng-template #hasSegments>
          <span
            *ngFor="let seg of day.segments; trackBy: trackBySegmentId"
            class="segment-chip"
            >{{ formatTime(seg.startTime) }} –
            {{ formatTime(seg.endTime) }}</span
          >
        </ng-template>
      </ng-template>
      <span class="total" [class.over-limit]="overLimit">
        Total: <strong>{{ formatTime(totalMinutes) }}</strong> /
        {{ formatTime(maxTotalMinutes) }}
      </span>
    </div>
  </div>

  <div class="day-summary">
    <app-daily-summary [date]="day.date" [events]="events"></app-daily-summary>
  </div>
</div>
